import React__default from 'react';
import FormTextarea from './FormTextarea.js';

const TextareaWrapper = (props) => {
    const { config: { tag, key, label, placeholder, boldLabel, showErrorIcon, disabled, disablePaste, type, onFocus, onBlur, rows, cols, subLabel, inCollapse }, keySuffix } = props;
    return (React__default.createElement(FormTextarea, { tag: tag, name: `${key}${keySuffix || ''}`, label: label, subLabel: subLabel, boldLabel: boldLabel, showErrors: true, placeholder: placeholder, showErrorIcon: showErrorIcon, disabled: disabled, disablePaste: disablePaste, type: type, onFocus: onFocus, onBlur: onBlur, rows: rows, cols: cols, inCollapse: inCollapse }));
};

export { TextareaWrapper as default };
//# sourceMappingURL=TextareaWrapper.js.map
